import { Inspector } from '../components/Inspector';
import { usePlay } from '../play/PlayController';
import type { BrickInstance } from '../presentation/types';
import { useScene } from '../scene/SceneContext';

/** A persistent, package-composable view of the selected public object. */
export function ObjectInspector({ inst }: { inst: BrickInstance }) {
  const { table } = useScene();
  const play = usePlay();
  if (!play) return null;
  const object = play.inspected ? table.objects.get(play.inspected) : undefined;
  return (
    <div className={`brick-object-inspector${object ? ' is-selected' : ''}`} data-inspector-id={object?.id}>
      <Inspector
        table={table}
        objectId={object?.id ?? null}
        choices={play.choices ?? []}
        onClose={() => play.inspect(null)}
        onChoose={choiceId => {
          if (!object) return;
          const entry = play.targets.anchors.get(`obj:${object.id}`)?.find(candidate => candidate.choiceId === choiceId);
          if (entry) play.chooseEntry(`obj:${object.id}`, entry);
        }}
        label={typeof inst.props?.label === 'string' ? inst.props.label : 'Details'}
      />
    </div>
  );
}
